import theme from '../styles/theme';

export const COMMISSIONS_HEADER_BG = theme.colors.neutral.bg.regular || '#F5F7FA';

export const commissionsTableStyles = `
  .commissions-configuration-table .rdt_Table {
    width: 100% !important;
    min-width: 100% !important;
  }

  .commissions-configuration-table .rdt_TableHead,
  .commissions-configuration-table .rdt_TableHead .rdt_TableHeadRow {
    background-color: ${COMMISSIONS_HEADER_BG} !important;
    gap: 0 !important;
    min-height: 48px;
    width: 100% !important;
    border-bottom: none !important;
  }

  .commissions-configuration-table .rdt_Table > div:first-child {
    border-top: none !important;
  }

  /* Expandable rows: header chevron slot inherits body cell styles (white) — force header gray */
  .commissions-configuration-table .rdt_TableHead .rdt_TableHeadRow > div:first-child {
    background-color: ${COMMISSIONS_HEADER_BG} !important;
    border: none !important;
    flex: 0 0 48px !important;
    min-width: 48px !important;
    max-width: 48px !important;
    padding-left: 16px !important;
    box-sizing: border-box;
  }

  .commissions-configuration-table .rdt_TableHead .rdt_TableCol,
  .commissions-configuration-table .rdt_TableHead .rdt_TableCol_Sortable {
    background-color: ${COMMISSIONS_HEADER_BG} !important;
    border: none !important;
    color: ${theme.colors.neutral.text.strong} !important;
    font-weight: 600;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }


  .commissions-configuration-table .rdt_TableRow .rdt_TableCell:first-child {
    padding-left: 16px !important;
    flex: 0 0 48px !important;
    min-width: 48px !important;
    max-width: 48px !important;
    background-color: ${theme.colors.neutral.bg.inverted} !important;
  }

  .commissions-configuration-table .rdt_TableRow {
    min-height: 44px;
    background-color: ${theme.colors.neutral.bg.inverted};
    border-bottom: none !important;
  }

  .commissions-configuration-table .rdt_TableCell {
    overflow: visible !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    vertical-align: middle;
  }

  .commissions-configuration-table .rdt_TableCell:nth-child(4) {
    overflow: visible !important;
  }

  .commissions-configuration-table .rdt_TableCell:nth-child(4) > div {
    overflow: visible !important;
  }

  .commissions-configuration-table .rdt_TableRow .rdt_TableCell:nth-child(4):has(ul) {
    position: relative !important;
    z-index: 1000 !important;
  }

  .commissions-configuration-table .rdt_TableCell:nth-child(2),
  .commissions-configuration-table .rdt_TableCell:nth-child(3) {
    overflow: hidden !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown > div,
  .commissions-configuration-table .commissions-configuration-cell-dropdown > div > div {
    margin-top: 0 !important;
    width: 100%;
    position: relative;
    overflow: visible !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-input > div {
    margin-top: 0 !important;
    width: 100%;
    position: relative;
  }

  .commissions-configuration-table .commissions-configuration-cell-input > div > div {
    margin-top: 0 !important;
    width: 100% !important;
    max-width: 112px;
    min-height: 36px;
    padding: 6px 10px !important;
    box-sizing: border-box;
  }

  .commissions-configuration-table .commissions-configuration-cell-input input {
    font-size: 14px !important;
    line-height: 20px !important;
    height: 20px !important;
    padding: 0 !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown {
    min-width: 200px;
    max-width: 100%;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown > div > div {
    margin-top: 0 !important;
    gap: 0 !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown > div > div > button {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    height: 36px !important;
    min-height: 36px !important;
    padding: 0 36px 0 12px !important;
    font-size: 14px !important;
    line-height: normal !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown > div > div > button > span {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    width: auto !important;
    max-width: calc(100% - 8px) !important;
    text-align: left !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown > div > div > button i {
    position: absolute !important;
    right: 12px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown ul {
    z-index: 10001 !important;
    min-width: 100% !important;
  }

  .commissions-configuration-table .commissions-configuration-cell-dropdown ul button {
    position: static !important;
    height: 36px !important;
    min-height: 36px !important;
    padding: 4px 20px !important;
    line-height: normal !important;
    width: 100% !important;
  }


  .commissions-configuration-table .rdt_ExpanderRow {
    background-color: ${theme.colors.neutral.bg.regular};
    overflow: visible !important;
  }

  .commissions-configuration-table .rdt_ExpanderRow > div {
    overflow: visible !important;
    width: 100% !important;
  }

  .commissions-configuration-table .commissions-intervals-editor {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 16px 16px 48px;
    background-color: ${theme.colors.neutral.bg.regular};
  }

  .commissions-configuration-table .commissions-intervals-editor-rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .commissions-configuration-table .commissions-intervals-editor-row {
    display: grid;
    grid-template-columns: 90px 90px 90px 40px;
    gap: 12px;
    align-items: start;
  }

  .commissions-configuration-table .commissions-intervals-editor-header {
    margin-bottom: 8px;
    align-items: center;
  }

  .commissions-configuration-table .commissions-intervals-editor-field {
    min-width: 0;
    width: 100%;
    background-color: ${theme.colors.neutral.bg.inverted};
    border: 2px solid ${theme.colors.neutral.border.weak};
    border-radius: ${theme.borderRadius['border-radius-2']};
    overflow: hidden;
  }

  .commissions-configuration-table .commissions-intervals-editor-field:focus-within {
    border-color: ${theme.colors['info'].border.regular};
  }

  .commissions-configuration-table .commissions-intervals-editor-field > div {
    width: 100% !important;
    max-width: none !important;
  }

  .commissions-configuration-table .commissions-intervals-editor-field > div > div {
    width: 100% !important;
    max-width: none !important;
    margin-top: 0 !important;
    min-height: 36px;
    padding: 0 !important;
    box-sizing: border-box;
    border: none !important;
    box-shadow: none !important;
  }

  .commissions-configuration-table .commissions-intervals-editor-field input {
    width: 100% !important;
    font-size: 14px !important;
    line-height: 20px !important;
    height: 36px !important;
    padding: 4px 10px !important;
    box-sizing: border-box !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .commissions-configuration-table .commissions-intervals-editor-actions {
    margin-top: 12px;
  }

  .commissions-configuration-table .commissions-edit-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${theme.borderRadius['border-radius-3']};
    background-color: ${theme.colors['info'].bg.inverted};
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .commissions-configuration-table .commissions-edit-icon * {
    cursor: pointer !important;
    pointer-events: none;
  }

  .commissions-configuration-table .commissions-edit-icon:hover {
    background-color: ${theme.colors['info'].bg.regular};
  }

  .commissions-configuration-table .commissions-edit-icon:hover * {
    color: ${theme.colors['neutral'].text.inverted} !important;
    fill: ${theme.colors['neutral'].text.inverted} !important;
  }

  .commissions-configuration-table .commissions-edit-icon:active {
    background-color: ${theme.colors['info'].bg.strong};
  }

  .commissions-configuration-table .commissions-edit-icon:focus-visible {
    outline: 2px solid ${theme.colors['info'].border.regular};
    outline-offset: 2px;
  }

  .commissions-configuration-table .commissions-delete-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: ${theme.borderRadius['border-radius-3']};
    background-color: #FEE2E2;
    cursor: pointer;
    transition: all 0.15s ease;
    align-self: center;
  }

  .commissions-configuration-table .commissions-delete-icon * {
    cursor: pointer !important;
    pointer-events: none;
  }

  .commissions-configuration-table .commissions-delete-icon:hover {
    background-color: ${theme.colors['danger'].bg.regular};
  }

  .commissions-configuration-table .commissions-delete-icon:hover * {
    color: ${theme.colors['neutral'].text.inverted} !important;
    fill: ${theme.colors['neutral'].text.inverted} !important;
  }

  .commissions-configuration-table .commissions-delete-icon:active {
    background-color: ${theme.colors['danger'].border.strong};
  }

  .commissions-configuration-table .commissions-delete-icon:focus-visible {
    outline: 2px solid ${theme.colors['danger'].border.regular};
    outline-offset: 2px;
  }

  .commissions-configuration-table .commissions-intervals-hint {
    display: block;
    font-size: 11px;
    line-height: 14px;
    margin-top: 2px;
    color: ${theme.colors['neutral'].text.weak};
  }

  .commissions-configuration-table .commissions-intervals-hint--warning {
    color: ${theme.colors['danger'].text.regular};
  }
`;
